import * as React from 'react';
import { EPaymentMethodType } from '../../../../../../../types/redux/paymentMethods';
import othersIcon from './assets/others.png';

interface IProps {
  type: EPaymentMethodType;
}

export const Icon = (props: IProps) => {
  switch (props.type) {
    case EPaymentMethodType.Others:
      return <img src={othersIcon} width="36" height="36" />;

    default:
      return null;
  }
};
